// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"tooltip_Tooltip__3d2qK","Body":"tooltip_Body__3sY8j","Text":"tooltip_Text__kTZVT"};